import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const SoundLevelAnimatedIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    {/* Speaker base (always visible) */}
    <path
      d="M7.9502 2.34958C8.10167 2.23616 8.30436 2.21807 8.47363 2.30271C8.64302 2.3874 8.75 2.56059 8.75 2.74997V13.25C8.75 13.4394 8.64302 13.6125 8.47363 13.6972C8.30436 13.7819 8.10167 13.7638 7.9502 13.6504L4.08301 10.75H1.75C1.47386 10.75 1.25 10.5261 1.25 10.25V5.74997C1.25 5.47383 1.47386 5.24997 1.75 5.24997H4.08301L7.9502 2.34958ZM4.5498 6.15036C4.46332 6.21512 4.35805 6.24997 4.25 6.24997H2.25V9.74997H4.25C4.35805 9.74997 4.46332 9.78482 4.5498 9.84958L7.75 12.249V3.74997L4.5498 6.15036Z"
      fill="currentColor"
    />
    {/* First sound line */}
    <path
      d="M11.25 7.99997C11.25 7.52137 11.0621 7.19761 10.876 6.98825C10.7812 6.88163 10.6864 6.80487 10.6172 6.75583C10.5829 6.73155 10.5556 6.71481 10.5391 6.70505C10.5335 6.70177 10.5293 6.69886 10.5264 6.69724C10.2794 6.57374 10.1792 6.27333 10.3027 6.02634C10.4108 5.81025 10.6543 5.70643 10.8789 5.76657L10.9736 5.80271L10.9834 5.80759C10.9877 5.80981 10.9929 5.81308 10.999 5.81638C11.0113 5.82305 11.0278 5.83152 11.0469 5.84275C11.085 5.86522 11.136 5.89738 11.1953 5.93943C11.3135 6.02317 11.4689 6.14972 11.624 6.32419C11.9379 6.67735 12.25 7.22875 12.25 7.99997C12.25 8.77119 11.9379 9.3226 11.624 9.67575C11.4689 9.85022 11.3135 9.97678 11.1953 10.0605C11.136 10.1026 11.085 10.1347 11.0469 10.1572C11.0278 10.1684 11.0113 10.1769 10.999 10.1836C10.9929 10.1869 10.9877 10.1901 10.9834 10.1924L10.9756 10.1963L10.9736 10.1972C10.7266 10.3207 10.4262 10.2206 10.3027 9.97361C10.1798 9.72766 10.2787 9.42912 10.5234 9.30466C10.5258 9.30336 10.531 9.29964 10.5391 9.29489C10.5556 9.28514 10.5829 9.2684 10.6172 9.24411C10.6864 9.19508 10.7812 9.11832 10.876 9.01169C11.0621 8.80234 11.25 8.47858 11.25 7.99997Z"
      fill="currentColor"
      opacity="0"
    >
      <animate
        attributeName="opacity"
        begin="0s"
        dur="1.2s"
        keyTimes="0;0.5;0.75;1"
        repeatCount="indefinite"
        values="0;1;1;0"
      />
    </path>
    {/* Second sound line */}
    <path
      d="M14.25 7.99997C14.25 6.95161 14.0182 6.11193 13.5791 5.42575C13.1389 4.73787 12.4664 4.16728 11.5264 3.69724C11.2794 3.57374 11.1792 3.27333 11.3027 3.02634C11.4262 2.77935 11.7266 2.67921 11.9736 2.80271C13.0335 3.33265 13.8611 4.01213 14.4209 4.88669C14.9817 5.763 15.25 6.79839 15.25 7.99997C15.25 9.20156 14.9817 10.2369 14.4209 11.1133C13.8611 11.9878 13.0335 12.6673 11.9736 13.1972C11.7266 13.3207 11.4262 13.2206 11.3027 12.9736C11.1792 12.7266 11.2794 12.4262 11.5264 12.3027C12.4664 11.8327 13.1389 11.2621 13.5791 10.5742C14.0182 9.88802 14.25 9.04833 14.25 7.99997Z"
      fill="currentColor"
      opacity="0"
    >
      <animate
        attributeName="opacity"
        begin="0s"
        dur="1.2s"
        keyTimes="0;0.5;0.75;1"
        repeatCount="indefinite"
        values="0;0;1;0"
      />
    </path>
  </svg>
);
